import { GlobalEvent } from './global-events';

export class GlobalEventModel {
  public eventType: GlobalEvent | null = null;
  public payload: any | null = null;
}
